/* eslint-disable import/prefer-default-export */
/** 抽奖引导疲劳度
 * showTimes 弹出的次数
 * lastShowTime 上一次弹出的时间
 */
export const GUID_STORAGE = 'lottery_guid';

/** 抽奖是否设置提醒 */
export const LOTTERY_SUBSCRIBED = 'remind_subscribed';


export const VIP_BIZ = {
  BIKE: 1,
  TAXI: 2,
  HITCH: 3,
  TRAIN: 4,
  HOTEL: 5,
  SCENE: 6,
  RENT: 7,
  QUICK_SEND: 8,
  GAS: 9,
  GOODS: 10,
  BATTERY: 11,
  FINANCIAL: 12, // 哈啰金融
};
/** 活动版本
 * 对应后台 版本
 * https://fat-member.hellobike.cn/#/member/manage
 *
*/
export const PropVersionMap = {
  /** 普通权益 */
  NORMAL: 'normal',
  /** 阶梯权益 */
  LADDER: 'ladder',
  /** 随心骑 */
  RIDE: 'ride',
  /** 随心骑-APP专享 */
  RIDE_APP: 'ride_app',
  /** 阶梯权益-APP专享 */
  LADDER_APP: 'ladder_app',
  /** 随心骑-体验版 */
  RIDE_TRIAL: 'ride_trial',
  /** 随心骑-通用版 */
  RIDE_UNIVERSAL: 'ride_universal',
  /** 助力车/轻松骑 */
  RIDE_EBIKE: 'ride_ebike',
  /** 助力车-APP专享 */
  RIDE_EBIKE_APP: 'ride_ebike_app',
  /** 阶梯融合版 */
  LADDER_BLEND: 'ladder_blend',
  /** 阶梯融合版2 */
  LADDER_BLEND_TWO: 'ladder_blend_two',
  /** 助力车-15次 */
  RIDE_EBIKE_FIFTEEN: 'ride_ebike_fifteen',
  /** 助力车-30次 */
  RIDE_EBIKE_THIRTY: 'ride_ebike_thirty',
  /** 助力车-聚合版本 */
  RIDE_AGG_EBIKE: 'ride_agg_ebike',
  /** 随心骑-稳健版 */
  RIDE_STEADY_VERSION: 'ride_steady_version',
  /** 随心骑-激进版 */
  RIDE_RADICAL_VERSION: 'ride_radical_version',
  /** 助力车-95折版本" */
  LADDER_DISCOUNT_95_RATE: 'ladder_discount_95_rate',
  // RIDE_BLEND_TWO: 'ride_blend_two', // 没这个版本
  /** 随心骑-1分骑版本 */
  RIDE_ONE_CENT: 'ride_one_cent',
};
/** 骑行卡状态枚举 */
export const RideCardStatusEnum = {
  RECEIVABLE: 'receivable',
  WAIT_FOR_RECEIVE: 'wait-for-receive',
};
/** 联名会员权益状态 */
export const UnionRightsStatus = {
  /** 待领取 */
  WAIT_RECEIVE: 1,
  /** 已领取 */
  RECEIVED: 2,
};
/** Tab背景图片配置 */
export const TAB_BACKGROUND_IMAGES = {
  /** 普通VIP背景图片 */
  vip: {
    2: ['https://m.hellobike.com/fd1ac901_20.png', 'https://m.hellobike.com/a6bea13e_21.png'],
    3: ['https://m.hellobike.com/9f5b87a0_30.png', 'https://m.hellobike.com/f966ae0c_31.png', 'https://m.hellobike.com/ebb275e4_32.png'],
  },
  /** 免费权益VIP背景图片 */
  freeRightsVip: {
    2: ['https://m.hellobike.com/a8713ada_20mian.png', 'https://m.hellobike.com/fe00eb28_21mian.png'],
    3: ['https://m.hellobike.com/ba5d69e1_30mian.png', 'https://m.hellobike.com/b4a07ab5_31mian.png', 'https://m.hellobike.com/6f299fb1_32mian.png'],
  },
};
